import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "text-truncate" }
const _hoisted_3 = { class: "text-truncate" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreviewLink = _resolveComponent("PreviewLink")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_VZDeleteModal = _resolveComponent("VZDeleteModal")!
  const _component_SiteDetailModal = _resolveComponent("SiteDetailModal")!
  const _component_AddEditModal = _resolveComponent("AddEditModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Datatable, {
      "table-data": _ctx.tableData,
      "table-header": _ctx.tableHeader,
      total: _ctx.total,
      rowsPerPage: _ctx.rowsPerPage,
      page: _ctx.page,
      loading: _ctx.loading,
      showSearch: _ctx.showSearch,
      defaultFilter: _ctx.defaultFilter,
      bulkDelete: _ctx.bulkDelete,
      tableForm: _ctx.formData,
      viewName: "userSites",
      addButtonText: `${_ctx.t('pages.user.assignSite')}`,
      onQueryUpdate: _ctx.syncQuery,
      onFormSubmit: _ctx.submit,
      permissions: _ctx.permissionModel,
      ref: "Datatable"
    }, {
      "cell-siteName": _withCtx(({ row: user }) => [
        _createTextVNode(_toDisplayString(user.siteName) + " ", 1),
        _createVNode(_component_PreviewLink, {
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
          routerName: {
          name: 'detail.site',
          params: { id: user.siteId },
        }
        }, null, 8, ["routerName"])
      ]),
      "cell-roleName": _withCtx(({ row: user }) => [
        (user.roleName)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["badge fw-bold m-1", _ctx.getClass(user.roleName)])
            }, _toDisplayString(user.roleName), 3))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-sm btn-primary",
              onClick: ($event: any) => (_ctx.openRoleModal(user))
            }, _toDisplayString(_ctx.t("pages.user.assignRole")), 9, _hoisted_1))
      ]),
      "cell-code": _withCtx(({ row: user }) => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(user.code), 1)
      ]),
      "cell-createdDate": _withCtx(({ row: user }) => [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.format.DateTime(user.createdDate)), 1)
      ]),
      "cell-status": _withCtx(({ row: user }) => [
        _createElementVNode("span", {
          class: _normalizeClass(["text-truncate fw-bolder", {
          'badge badge-success': user.status?.toLowerCase() === 'active',

          'badge badge-danger': user.status?.toLowerCase() !== 'active',
        }])
        }, _toDisplayString(_ctx.format.TitleCase(user.status?.toLowerCase())), 3)
      ]),
      "cell-actions": _withCtx(({ row: user }) => [
        (_ctx.hasPermission(_ctx.permissionModel.delete))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _withModifiers(($event: any) => (_ctx.openDeleteDialog(user)), ["stop"]),
              class: "btn btn-icon btn-danger btn-circle btn-sm ms-3"
            }, _hoisted_6, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "defaultFilter", "bulkDelete", "tableForm", "addButtonText", "onQueryUpdate", "onFormSubmit", "permissions"]),
    _createVNode(_component_VZDeleteModal, {
      viewName: "userSites",
      showDialog: _ctx.showDeleteDialog,
      selectedForAction: [_ctx.selectedForAction.webId],
      deleteText: `${_ctx.t('validation.sureToDelete')} ${
      _ctx.selectedForAction.siteName
    }?`,
      pageName: "branch",
      onClose: _ctx.refreshList
    }, null, 8, ["showDialog", "selectedForAction", "deleteText", "onClose"]),
    _createVNode(_component_SiteDetailModal, {
      viewName: "site_detail_modal",
      data: _ctx.selectedForSite,
      showDialog: _ctx.showDetailDialog,
      onCloseDetail: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDetailDialog = false))
    }, null, 8, ["data", "showDialog"]),
    _createVNode(_component_AddEditModal, {
      viewName: "user_site_modal",
      modelValue: _ctx.showAddSiteRole,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showAddSiteRole) = $event)),
      data: _ctx.computedUserSiteModalData,
      "on@onClose": _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAddSiteRole = false)),
      onOnSubmit: _ctx.submitSiteRole,
      onOnCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showAddSiteRole = false))
    }, null, 8, ["modelValue", "data", "onOnSubmit"])
  ], 64))
}